import { retryDynamicImport } from "@shared/lib"
import {
	imprint,
	termsAndConditions,
	privacyPolicy,
	openSourceAttribution,
} from "@shared/routes"
import { RouteObject } from "react-router-dom"

export default [
	{
		path: imprint,
		lazy: () =>
			retryDynamicImport(() => import("../imprint")).then(m => ({
				Component: m.ImprintPage,
			})),
	},
	{
		path: termsAndConditions,
		lazy: () =>
			retryDynamicImport(() => import("../terms-and-conditions")).then(
				m => ({
					Component: m.TermsAndConditionsPage,
				}),
			),
	},
	{
		path: privacyPolicy,
		lazy: () =>
			retryDynamicImport(() => import("../privacy-policy")).then(m => ({
				Component: m.PrivacyPolicyPage,
			})),
	},
	{
		path: openSourceAttribution,
		lazy: () =>
			retryDynamicImport(() => import("../open-source-attribution")).then(
				m => ({
					Component: m.OpenSourceAttributionPage,
				}),
			),
	},
] as RouteObject[]
